import React from 'react';
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import { Box, Button, Divider, Typography } from '@material-ui/core';
import {
	BASIC_TOUR_STEPS,
	NEXT,
	CUSTOM_TOOLTIP_START,
	CUSTOM_TOOLTIP_SELECT,
	CUSTOM_TOOLTIP_PREVIEW,
	CUSTOM_OKAY_TO_START,
	CUSTOM_NAME_DATASET,
	CUSTOM_EDIT_DATASET,
	CUSTOM_GUIDE_CLICK_TO_START,
	CUSTOM_GUIDE_SELECT_DC,
	CUSTOM_GUIDE_DISPLAY_TABLE,
	CUSTOM_GUIDE_SELECT_SAVE,
	CUSTOM_GUIDE_GIVE_NAME,
	GET_CUSTOM_GUIDE_EDIT
} from 'constants/constant';

import useStyles from './ftux.style';
import { CDTourFlag } from 'constants/constant';
import { trackEventInfo } from 'helper/analytics';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';
import { setCustomDatasetTour } from 'components/UserTour/Tour.action';

const TooltipComponent = (props) => {
	const LAST_STEP_INDEX = 5;
	const classes = useStyles();
	const dispatch = useDispatch();
	const { content } = props.step;

	const stepCount = `(${props.index + 1}/6)`;
	const btnText = props.index === LAST_STEP_INDEX ? BASIC_TOUR_STEPS.GOT_IT : `${NEXT}${stepCount}`;

	const onClose = (e) => {
		// Reset the Tour reducer
		dispatch(
			setCustomDatasetTour({
				CDTourRun: false,
				CDTourStepIndex: 0
			})
		);
		// Close the Joyride tooltip
		props.closeProps.onClick(e);
	};

	const onButtonClick = () => {
		const tourData = {
			CDTourStepIndex: props.index + 1
		};
		if (props.index === LAST_STEP_INDEX) {
			tourData.CDTourRun = false;
			localStorage.setItem(CDTourFlag, true);
			trackEventInfo({
				type: EVENTS.CLICK,
				actionOn: ACTION_ON.CUSTOM_DATASET_TOUR_GOT_IT,
				location: PAGE_ID.TEMPLATES
			});
		}
		dispatch(setCustomDatasetTour(tourData));
	};

	return (
		<Box className={classes.tooltipContainer}>
			<Box className={classes.tooltipHeader}>
				{/* Heading */}
				<Typography>{content?.heading}</Typography>
				{/* Close the tooltip */}
				<CloseIcon className={classes.tooltipCloseIcon} onClick={onClose} />
			</Box>
			{/* Content */}
			<Box>{content?.message}</Box>
			<Divider />
			<Box className={classes.tooltipFooter}>
				{/* Next button */}
				<Button
					disableRipple
					disableTouchRipple
					className={classes.nextBtn}
					onClick={onButtonClick}>
					{btnText}
				</Button>
			</Box>
		</Box>
	);
};

const disableBeacon = true;

const ContentBox = (props) => <Box padding={'0 24px 24px'}>{props.children}</Box>;
/**
 * Steps for Custom Dataset Tour
 */
export const steps = [
	{
		disableBeacon,
		placement: 'right',
		target: '#template_-1',
		content: {
			heading: CUSTOM_TOOLTIP_START,
			message: <ContentBox>{CUSTOM_GUIDE_CLICK_TO_START}</ContentBox>
		}
	},
	{
		disableBeacon,
		target: '#leftPanel',
		placement: 'right',
		content: {
			heading: CUSTOM_TOOLTIP_SELECT,
			message: <ContentBox>{CUSTOM_GUIDE_SELECT_DC}</ContentBox>
		}
	},
	{
		disableBeacon,
		target: '#rightPanel',
		placement: 'left',
		content: {
			heading: CUSTOM_TOOLTIP_PREVIEW,
			message: <ContentBox>{CUSTOM_GUIDE_DISPLAY_TABLE}</ContentBox>
		}
	},
	{
		disableBeacon,
		target: '#custom-dataset-dialog-actions',
		placement: 'top-end',
		content: {
			heading: CUSTOM_OKAY_TO_START,
			message: <ContentBox>{CUSTOM_GUIDE_SELECT_SAVE}</ContentBox>
		}
	},
	{
		disableBeacon,
		target: '#save-dataset-dialog-box',
		placement: 'right',
		content: {
			heading: CUSTOM_NAME_DATASET,
			message: <ContentBox>{CUSTOM_GUIDE_GIVE_NAME}</ContentBox>
		}
	},
	{
		disableBeacon,
		target: '#custom-dataset-name',
		placement: 'left',
		content: {
			heading: CUSTOM_EDIT_DATASET,
			message: <ContentBox>{GET_CUSTOM_GUIDE_EDIT(MoreIcon, { fontSize: 'small' })}</ContentBox>
		}
	}
];

export default TooltipComponent;
